(function () {
  function formatMoney(t, e = "") {
    "string" == typeof t && (t = t.replace(".", ""));
    const i = /\{\{\s*(\w+)\s*\}\}/,
      n = e || window.themeHDN.settings.moneyFormat;
    function s(t, e) {
      return null == t || t != t ? e : t;
    }
    function r(t, e, i, n) {
      if (((e = s(e, 2)), (i = s(i, ",")), (n = s(n, ".")), isNaN(t) || null == t)) return 0;
      let r = (t = (t / 100).toFixed(e)).split(".");
      return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (r[1] ? n + r[1] : "");
    }
    let a = "";
    switch (n.match(i)[1]) {
      case "amount":
        a = r(t, 2);
        break;
      case "amount_no_decimals":
        a = r(t, 0);
        break;
      case "amount_with_space_separator":
        a = r(t, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        a = r(t, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        a = r(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        a = r(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        a = r(t, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        a = r(t, 0, "'");
    }
    return n.indexOf("with_comma_separator"), n.replace(i, a);
  }
  window.T4Custom = {
    swiperInit() {
      const els = document.querySelectorAll(".swiper-container");
      if (els.length) {
        els.forEach((el) => {
          const params = {
            scrollbar: {
              el: ".swiper-scrollbar",
              hide: false,
              draggable: true,
            },
          };
          const breakpoints = {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            // when window width is >= 480px
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            // when window width is >= 640px
            1025: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          };
          const config = el.dataset.swiper ? JSON.parse(el.dataset.swiper) : {};
          if (config.item_per_row) {
            breakpoints[1025].slidesPerView = config.item_per_row;
          }
          if (config.item_per_row_tb) {
            breakpoints[768].slidesPerView = config.item_per_row_tb;
          }
          if (config.item_per_row_mb) {
            breakpoints[320].slidesPerView = config.item_per_row_mb;
          }

          params.breakpoints = breakpoints;
          new Swiper(el, params);
        });
      }
    },
    compareInit() {
      const swatchs = document.querySelectorAll(".hdt-main-compare-form input[name=id]");
      if (swatchs && swatchs.length) {
        swatchs.forEach(function (swatch) {
          swatch.addEventListener("change", function (e) {
            const variant = e.target.value;
            const dom = e.target,
              productId = dom.dataset.id,
              wrapper = dom.closest(".hdt-compare-value"),
              productJson = wrapper ? wrapper.querySelector("[data-variants-metafields-json]") : null;
            if (!productJson) return;
            let productInfo = null;
            try {
              productInfo = JSON.parse(productJson.innerHTML);
            } catch (error) {
              console.log("error json", error);
            }
            if (!productInfo) return;
            const selected_variant = productInfo[variant];
            if (selected_variant) {
              Object.keys(selected_variant).forEach((key) => {
                //console.log(`.hdt-compare-item-${productId}.compare_${key}`)
                document.querySelector(`.hdt-compare-item-${productId}.compare_${key}`) &&
                  (document.querySelector(`.hdt-compare-item-${productId}.compare_${key}`).innerHTML =
                    selected_variant[key]);
              });

              const price_wrapper = document.querySelector('.hdt-compare-price__' + productId);
              if(price_wrapper) {
                price_wrapper.querySelector('.hdt-money') &&  (price_wrapper.querySelector('.hdt-money').innerHTML = formatMoney(selected_variant.price))
              }
            }
          });
        });
      }
    },
  };

  document.addEventListener("DOMContentLoaded", () => {
    window.T4Custom.swiperInit();
    window.T4Custom.compareInit();
    document.addEventListener("shopify:section:load", (e) => {
      console.log("Custom load");
      window.T4Custom.swiperInit();
    });
  });
})();
